import * as React from 'react';

import {Card} from '../card/card';
import {CodeBlock} from '../code-block/code-block';
import {Divider} from '../layout/divider';
import {CopyableLink} from '../link/copyable-link';
import {Link} from '../link/link';
import {Modal} from '../modal/modal';
import {PopoverInfo} from '../popover-info/popover-info';
import {ModalHeader} from '../typography/modal-header';
import {UppercaseLabel} from '../typography/uppercase-label';

type Props = {
    onClose: () => any;
    header: string;
    additionalContent?: React.ReactNode;
    codeSnippet: string;
    embedInfoPopoverText: string;
    copyableLinkLabel: string;
    copyableLinkDescription?: string;
    copyableLink: string;
};

export function EmbedOrShareModal(props: Props) {
    const [modalHeight, setModalHeight] = React.useState<number | null | undefined>(undefined);
    const modalContentRef = React.useRef<any>(null);

    React.useLayoutEffect(() => {
        if (modalContentRef.current) {
            // + 64 for additional modal padding around content
            setModalHeight(modalContentRef.current.clientHeight + 64);
        }
    }, [setModalHeight]);

    return (
        <Modal
            isOpen={true}
            canClickOutsideToClose={true}
            onClose={props.onClose}
            maxHeight={modalHeight || undefined}
        >
            <div ref={modalContentRef}>
                <ModalHeader>{props.header}</ModalHeader>
                {props.additionalContent}
                <CodeBlock
                    value={props.codeSnippet}
                    includeCopyButton={true}
                    height={205}
                    label={
                        <div className='flex align-center'>
                            Embed code{' '}
                            <PopoverInfo
                                info={
                                    <>
                                        {props.embedInfoPopoverText}{' '}
                                        <Link
                                            href='https://support.nutshell.com/en/articles/8429029-nutshell-forms-embed-forms-on-your-website'
                                            variant='primary'
                                            newTab={true}
                                            size='small'
                                        >
                                            Learn more
                                        </Link>
                                    </>
                                }
                            />
                        </div>
                    }
                    name='embedCode'
                />
                <Divider spacing={24} variant='line--horizontal' />
                <div>
                    {/* @ts-expect-error */}
                    <UppercaseLabel htmlFor='copyLink'>{props.copyableLinkLabel}</UppercaseLabel>
                    <Card
                        hasBorder={true}
                        hasShadow={false}
                        fitHeight={true}
                        backgroundColor='offWhite'
                    >
                        <div className='pad-16'>
                            {props.copyableLinkDescription && (
                                <div className='mb-8'>{props.copyableLinkDescription}</div>
                            )}
                            <CopyableLink
                                name='copyLink'
                                value={props.copyableLink}
                                size='big'
                                isWhite={true}
                            />
                        </div>
                    </Card>
                </div>
            </div>
        </Modal>
    );
}
